import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateFivePDFSection, TemplateFivePDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeAward } from "lib/redux/types";

export const Award = ({
  heading,
  awards,
  themeColor,
  enableMistakeHighlight = false,
}: {
  heading: string;
  awards: ResumeAward[];
  themeColor: string;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFivePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View key={idx} wrap={false} style={idx > 0 ? { marginTop: "6pt" } : {}}>
          <View style={{ width: "70%", marginTop: "2pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
            <View
              style={{
                marginTop: "2pt", //  spacing["0.5"] (6pt) to 2pt
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: "6pt", //  spacing["2"] (24pt) to 6pt
                }}
              >
                <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                  {award}
                </ResumePDFText>
                <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                  {issuer}
                </ResumePDFText>
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: "3pt" }}> {/* spacing["0.5"] (6pt) to 3pt */}
              <ResumePDFDescription 
                items={descriptions} 
                enableMistakeHighlight={enableMistakeHighlight}
                section="awards"
                itemIndex={idx}
              />
            </View>
          </View>
        </View>
      ))}
    </TemplateFivePDFSectionWithSubsections>
  );
};
